export default class SVG {
	constructor(svg) {
		this.svg = svg;
	}

	showElementsByIds(ids) {
		ids.forEach((svgId) => {
			const element = this.svg.getElementById(svgId);
			if (element) {
				element.style.display = "block";
			}
		});
	}

	addHideClassBySlug(slug, className = "nng-hide") {
		this.svg.querySelectorAll(`[id*="${slug}"]`).forEach((element) => {
			element.classList.add(className);
		});
	}

	addClass(element, className) {
		if (typeof element === "string" || element instanceof String) {
			element = this.svg.getElementById(element);
		}
		element.classList.add(className);
	}

	removeClass(element, className) {
		if (typeof element === "string" || element instanceof String) {
			element = this.svg.getElementById(element);
		}
		element.classList.remove(className);
	}

	toggleClass(element, hideClass = "nng-hide", showClass = "nng-show") {
		if (typeof element === "string" || element instanceof String) {
			element = this.svg.getElementById(element);
		}

		if (element.classList.contains(hideClass)) {
			element.classList.remove(hideClass);
			element.classList.add(showClass);
		} else {
			element.classList.remove(showClass);
			element.classList.add(hideClass);
		}
	}
}
